<template>
	<div>
<!--
	
-->

<div id="pag" style="position: absolute; top: 0;"></div>
<transition v-if="lightboxQuiz" name="menu-popover">
      <div class="lightbox" >
		
        <h2 class="closeX" @click="closeQuizLightbox()">
          <a>&#215;</a>
        </h2>
	

	
		  <div class="lightbox-quiz">
		
			<quiz :quizData="lightboxQuiz" :ModuleID="ModuleID" :closeQuizLightbox="closeQuizLightbox" :loadNewContent="loadNewContent" :completeQuiz="completeQuiz"></quiz>
		
		</div>
		
	
      

      </div>
</transition>

<!--
	
-->
<transition name="menu-popover">
      <div v-if="lightboxVideo" class="lightbox" @click="closeLightbox()">
        <h2 class="closeX" @click="closeLightbox()">
          <a>&#215;</a>
        </h2>
        <div class="lightbox-vid" v-html="lightboxVideo"></div>
        <!-- <img :src="lightboxImage" @click="closeLightbox()"/> -->
      </div>
    </transition>
	
	<div class="questions inside-banner mobile-top">
        <section class="pixelsbg bs-shadow" style="padding: 50px 0 30px;">
      <div class="container">
          <div class="container">
        <h1 class="text-white lh1" style="margin-bottom: 10px;">{{ course.Title }}</h1>


		
			<p style="font-size: 18px; font-weight: 300; color: #fff;">
				<small v-if="Number(course.Length) < 60">About {{course.Length}} minutes in length</small> 
				
				<small v-else-if="Math.round(Number(course.Length) / 60) === 1">
				About {{ roundedHalfHour(Number(course.Length)) }} Hour in length
				</small>
				<small v-else>
				About {{ roundedHalfHour(Number(course.Length)) }} Hours in length
				</small>
				
			</p>
		
	
	
	<!--
		        <p class="text-white lh1" style="font-size: 18px; font-weight: 300; margin-bottom: 30px;">{{ course[0].Description }} </p>

	
	-->
	

		
      </div>
	  
      </div>
	  
    </section>

    		<section class="faq-tease" style="margin-top: 20px; margin-bottom: 20px;">
			<div class="container">

                <div class="d-flex number-showing">
					<back-button/>
					<!--
                <router-link
                  :to="{ path: $store.state.route.from.fullPath }"
                  class="mb0 lh1 mrauto list-btn dib d-flex center"
                >
                  <i class="material-icons">keyboard_arrow_left</i>
                  Back
                </router-link>
			-->
            </div>


				<div
					v-if="loading == true"
					class="col-xs-12 col-sm-12 col-12 col-lg-12"
					style="
              min-height: 302px; display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 20px;"
				>
					<div class="flex-box-wrap">
						<div class="flex-internal">
							<atom-spinner
								:animation-duration="1000"
								:size="40"
								:color="'#333'"
							/>
							<p style="color:#333;">Loading......</p>
						</div>
					</div>
				</div>

				<div v-else class="accordion" id="faq-01" data-config-id="faq">
					<div class="row">
						<div class="col-12 col-sm-12 block">

							<div class="mb-2 border-bottom bgwhite bs-shadow" style="padding: 20px;">
								<h3>Course Overview:</h3>
								<hr/>
								<p>{{ course.Description }}</p>
								<hr/>
								<h3 v-if="block3Docs.length" style="margin-bottom: 10px!important;     font-size: 1.3rem;">Product Training:</h3>
								<ul>
									<li 
									v-for="file in block3Docs" 
								style="margin-bottom: 20px;"
									:key="file.ID" class="doc-item">
										<h6>{{ file.FileName }}</h6>

										<button v-if="file.ContentType == 'VID'" @click="showLightboxVideo(file.Link)" class="list-btn"><svg class="svg-style" fill="#fff" viewBox="0 0 24 24"><path d="M8 5v14l11-7L8 5z"></path></svg>Play Video</button>
										<button v-else-if="file.ContentType == 'PDF'" @click="openPdfInNewTab(file.Link)" class="list-btn"><svg class="svg-style2" fill="#fff" viewBox="0 0 24 24"><path d="M6 2h6l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm6 1.5V8h4.5L12 3.5zM8 12h2.5c1.1 0 2 .9 2 2s-.9 2-2 2H9v2H8v-6zm1 1v2h1.5c.55 0 1-.45 1-1s-.45-1-1-1H9zm7-1h-2.5c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2H16v-5zm-1 1v3h-.5c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h.5z"></path></svg>View PDF</button>

										<!--
																				<a v-else-if="file.ContentType='PDF'" style="color: #000" href="https://spacesaver.widen.net/view/pdf/o5rwzelk43/Installation-Academy---PDF-Cantilever-Shelving---Configura-Outputs.pdf?t.download=true&amp;u=sphzbh" target="_blank" rel="noopener noreferrer" class="inline-flex items-center text-[#00b4b4] font-medium underline focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"><svg class="svg-style" fill="#000" viewBox="0 0 24 24"><path d="M6 2h6l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm6 1.5V8h4.5L12 3.5zM8 12h2.5c1.1 0 2 .9 2 2s-.9 2-2 2H9v2H8v-6zm1 1v2h1.5c.55 0 1-.45 1-1s-.45-1-1-1H9zm7-1h-2.5c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2H16v-5zm-1 1v3h-.5c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h.5z"></path></svg>View PDF</a>

										-->
										<!--
										<a :href="file.Link" target="_blank" rel="noopener noreferrer">
										{{ file.FileName }}
										</a>
										-->
										
										

									</li>
								</ul>
								<div v-if="block3PublishedQuizzes?.length" class="mt-6">
								<ul class="space-y-4" style="background: rgb(248, 250, 252); border: none; padding: 40px 40px 20px 40px;">
									<li v-for="quiz in block3PublishedQuizzes" :key="quiz.ID" style="list-style-type: none; margin-bottom: 20px;">
							
									<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px; padding: 0;">
										<h3 class="font-semibold" style="font-size: 1.3rem;" :class="{'complete': quiz.complete, 'strikethrough': true}">{{ quiz.Title }}</h3>
										<div v-if="quiz.complete"><h6><b>Completed:</b> {{  $moment(quiz.completedAt).format("MMM Do YYYY")  }}</h6></div>
										<div v-else-if="quiz.enrolled"><h6><b>Enrolled:</b> {{  $moment(quiz.enrolledAt).format("MMM Do YYYY")  }}</h6></div>
									</div>
								
									
									<!-- Show questions (optional preview) -->
									<div v-if="quiz.questions?.length" class="mt-2 text-sm text-gray-600">
										{{ quiz.questions.length }} question{{ quiz.questions.length !== 1 ? 's' : '' }}
									</div>

									<!-- Button to start quiz / open in lightbox etc. -->
									 <button 
										v-if="quiz.complete"
										@click="showLightboxQuiz(quiz, quiz.ID)" 
										class="list-btn"
									>
										Review Quiz
									</button>
									<button 
										v-else
										@click="showLightboxQuiz(quiz, quiz.ID)" 
										class="list-btn"
									>
										Start Quiz
									</button>
									</li>
								</ul>
								</div>
								


								
								<ul>
									<li 
									v-for="file in block5Docs" 
								style="margin-bottom: 20px;"
									:key="file.ID" class="doc-item">
										<h6>{{ file.FileName }}</h6>

										<button v-if="file.ContentType == 'VID'" @click="showLightboxVideo(file.Link)" class="list-btn"><svg class="svg-style" fill="#fff" viewBox="0 0 24 24"><path d="M8 5v14l11-7L8 5z"></path></svg>Play Video</button>
										<button v-else-if="file.ContentType == 'PDF'" @click="openPdfInNewTab(file.Link)" class="list-btn"><svg class="svg-style2" fill="#fff" viewBox="0 0 24 24"><path d="M6 2h6l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm6 1.5V8h4.5L12 3.5zM8 12h2.5c1.1 0 2 .9 2 2s-.9 2-2 2H9v2H8v-6zm1 1v2h1.5c.55 0 1-.45 1-1s-.45-1-1-1H9zm7-1h-2.5c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2H16v-5zm-1 1v3h-.5c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h.5z"></path></svg>View PDF</button>

										<!--
																				<a v-else-if="file.ContentType='PDF'" style="color: #000" href="https://spacesaver.widen.net/view/pdf/o5rwzelk43/Installation-Academy---PDF-Cantilever-Shelving---Configura-Outputs.pdf?t.download=true&amp;u=sphzbh" target="_blank" rel="noopener noreferrer" class="inline-flex items-center text-[#00b4b4] font-medium underline focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"><svg class="svg-style" fill="#000" viewBox="0 0 24 24"><path d="M6 2h6l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm6 1.5V8h4.5L12 3.5zM8 12h2.5c1.1 0 2 .9 2 2s-.9 2-2 2H9v2H8v-6zm1 1v2h1.5c.55 0 1-.45 1-1s-.45-1-1-1H9zm7-1h-2.5c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2H16v-5zm-1 1v3h-.5c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h.5z"></path></svg>View PDF</a>

										-->
										<!--
										<a :href="file.Link" target="_blank" rel="noopener noreferrer">
										{{ file.FileName }}
										</a>
										-->
										
										

									</li>
								</ul>
								<div v-if="block5PublishedQuizzes?.length" class="mt-6">
								<ul class="space-y-4" style="background: rgb(248, 250, 252); border: none; padding: 40px 40px 20px 40px;">
									<li v-for="quiz in block5PublishedQuizzes" :key="quiz.ID" style="list-style-type: none; margin-bottom: 20px;">
							
									<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px; padding: 0;">
										<h3 class="font-semibold" style="font-size: 1.3rem;" :class="{'complete': quiz.complete, 'strikethrough': true}">{{ quiz.Title }}</h3>
										<div v-if="quiz.complete"><h6><b>Completed:</b> {{  $moment(quiz.completedAt).format("MMM Do YYYY")  }}</h6></div>
										<div v-else-if="quiz.enrolled"><h6><b>Enrolled:</b> {{  $moment(quiz.enrolledAt).format("MMM Do YYYY")  }}</h6></div>

									</div>
								
									
									<!-- Show questions (optional preview) -->
									<div v-if="quiz.questions?.length" class="mt-2 text-sm text-gray-600">
										{{ quiz.questions.length }} question{{ quiz.questions.length !== 1 ? 's' : '' }}
									</div>

									<!-- Button to start quiz / open in lightbox etc. -->
									 <button 
										v-if="quiz.complete"
										@click="showLightboxQuiz(quiz, quiz.ID)" 
										class="list-btn"
									>
										Review Quiz
									</button>
									<button 
										v-else
										@click="showLightboxQuiz(quiz, quiz.ID)" 
										class="list-btn"
									>
										Start Quiz
									</button>
									</li>
								</ul>
								</div>




								<h3 v-if="block4Docs.length" style="margin-bottom: 10px!important; font-size: 1.3rem;">Sales Training:</h3>
								
								<ul>
									<li 
									v-for="file in block4Docs" 
								style="margin-bottom: 20px;"
									:key="file.ID" class="doc-item">
										<h6>{{ file.FileName }}</h6>

										<button v-if="file.ContentType == 'VID'" @click="showLightboxVideo(file.Link)" class="list-btn"><svg class="svg-style" fill="#fff" viewBox="0 0 24 24"><path d="M8 5v14l11-7L8 5z"></path></svg>Play Video</button>
										<button v-else-if="file.ContentType == 'PDF'" @click="openPdfInNewTab(file.Link)" class="list-btn"><svg class="svg-style2" fill="#fff" viewBox="0 0 24 24"><path d="M6 2h6l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm6 1.5V8h4.5L12 3.5zM8 12h2.5c1.1 0 2 .9 2 2s-.9 2-2 2H9v2H8v-6zm1 1v2h1.5c.55 0 1-.45 1-1s-.45-1-1-1H9zm7-1h-2.5c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2H16v-5zm-1 1v3h-.5c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h.5z"></path></svg>View PDF</button>

<!--
											<a v-else-if="file.ContentType='PDF'" style="color: #000" href="https://spacesaver.widen.net/view/pdf/o5rwzelk43/Installation-Academy---PDF-Cantilever-Shelving---Configura-Outputs.pdf?t.download=true&amp;u=sphzbh" target="_blank" rel="noopener noreferrer" class="inline-flex items-center text-[#00b4b4] font-medium underline focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"><svg class="svg-style" fill="#000" viewBox="0 0 24 24"><path d="M6 2h6l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zm6 1.5V8h4.5L12 3.5zM8 12h2.5c1.1 0 2 .9 2 2s-.9 2-2 2H9v2H8v-6zm1 1v2h1.5c.55 0 1-.45 1-1s-.45-1-1-1H9zm7-1h-2.5c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2H16v-5zm-1 1v3h-.5c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h.5z"></path></svg>View PDF</a>
									
-->
										<!--
										<a :href="file.Link" target="_blank" rel="noopener noreferrer">
										{{ file.FileName }}
										</a>
										-->
										
									

							
									</li>
								</ul>

									<div v-if="block4PublishedQuizzes?.length" class="mt-6">
								<ul class="space-y-4" style="background: rgb(248, 250, 252); border: none; padding: 40px 40px 20px 40px;">
									<li v-for="quiz in block4PublishedQuizzes" :key="quiz.ID" style="list-style-type: none; margin-bottom: 20px;">
										<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px; padding: 0;">
											<h3 style="font-size: 1.3rem;" class="font-semibold" :class="{'complete': quiz.complete, 'strikethrough': true}">{{ quiz.Title }}</h3>
											<div v-if="quiz.complete"><h6><b>Completed:</b> {{  $moment(quiz.completedAt).format("MMM Do YYYY")  }}</h6></div>
											<div v-else-if="quiz.enrolled"><h6><b>Enrolled:</b> {{  $moment(quiz.enrolledAt).format("MMM Do YYYY")  }}</h6></div>

										</div>
									
				
									
									<!-- Show questions (optional preview) -->
									<div v-if="quiz.questions?.length" class="mt-2 text-sm text-gray-600">
										{{ quiz.questions.length }} question{{ quiz.questions.length !== 1 ? 's' : '' }}
									</div>

									<!-- Button to start quiz / open in lightbox etc. -->
									<button 
										v-if="quiz.complete"
										@click="showLightboxQuiz(quiz, quiz.ID)" 
										class="list-btn"
									>
										Review Quiz
									</button>
									<button 
										v-else
										@click="showLightboxQuiz(quiz, quiz.ID)" 
										class="list-btn"
									>
										Start Quiz
									</button>
									</li>
								</ul>
								</div>
							</div>
						</div>
						
					
				
					</div>
					</div>
				</div>
			
		
		</section>

	</div>
</div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import TrainingData from "../data/trainingData.json"
import Quiz from '../components/ProductQuiz.vue';
import TrainingPagination from '@/components/Pagination/TrainingPagination.vue';
import BackButton from '@/components/Buttons/BackButton.vue';

//old auth with admin priveleges
//headers: {Authorization:'Bearer spacesaver/ab3f641f910eb693804bc5b097a5bda6'}

const auth = {
	headers: {
		Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
	},
};

export default {
	name: "FortCourse",
	components: {
		AtomSpinner,
		Quiz,
		TrainingPagination,
		BackButton
	},
	data() {
		return {
			server: import.meta.env.VITE_APP_SERVER_URL,
			// server: 'http://localhost:5002',
			pageSlug: "",
			currPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      		search: this.$route.query.search || '',
    		searchStarted: !!this.$route.query.search,
			selectedProduct: this.$route.query.product || null,
			activeProduct: this.$route.query.product || null,
			countOfPage: 6,
			msg: "",
			offsetVal: 0,
			searchValue: "",
			lightboxVideo: "",
			lightboxQuiz: null,
            media: [],
            faqPosts: [],
			trainingData: [],
			loading: false,
			lightboxVideo: "",
			lightboxQuiz: null,
			ModuleID: null,
			complete: 0,
			congrats: 0,
			courseid: this.$route.params.id || null,
			course: null,
			courses: [
				{ id: 1, title: "EZ Power", category: "Mobile",description: "Learn how to configure initial preferences for Spacesaver’s EZ Power solution, designed for Eclipse powered mobile systems. This course covers setup essentials to ensure seamless integration and optimal performance without the need for on-site electricians.", image: "/training-thumbnails/EZPower-thumbnail.jpg", Length: "7" },
				{ id: 2, title: "Touchless Gesture Control", category: "Mobile", description: "Discover how Spacesaver’s Touchless Gesture Control enhances Eclipse powered mobile systems with hands-free operation. This course explains setup and functionality, productivity, and modernizing system aesthetics.", image: "/training-thumbnails/touchless-thumbnail.jpg", Length: 6 },
				{ id: 3, title: "UWR", category: "Weapons Storage", description: "Learn about Spacesaver’s Universal Weapons Rack updates designed for the U.S. military’s Next Gen Squad Weapons program. This course covers new cabinet sizes, angled brackets, and transport solutions for storing M7 rifles and M-250 machine guns efficiently and securely.", image: "/training-thumbnails/UWR-thumbnail.jpg", Length: 9 },
				{ id: 4, title: "Freestyle/Rival Lockers", category: "Lockers", description: "Explore Spacesaver’s Freestyle Lockers, designed for durability, flexibility, and customization to meet diverse storage needs. This course covers construction features, accessory options, and innovative configurations like pull-out benches and tiered lockers.", image: "/training-thumbnails/freestyle-thumbnail.jpg", Length: 12 },
				{ id: 5, title: "Flexible Shelving", category: "HighBay", description: "Explore Spacesaver’s Freestyle Lockers, designed for durability, flexibility, and customization to meet diverse storage needs. This course covers construction features, accessory options, and innovative configurations like pull-out benches and tiered lockers.", image: "/training-thumbnails/freestyle-thumbnail.jpg", Length: 14 },
				{ id: 6, title: "Mod-Glider Pro", category: "Art Racks", description: "Explore Spacesaver’s Freestyle Lockers, designed for durability, flexibility, and customization to meet diverse storage needs. This course covers construction features, accessory options, and innovative configurations like pull-out benches and tiered lockers.", image: "/training-thumbnails/freestyle-thumbnail.jpg", Length: 18 },

			],
			products: [
				/*
				{ id: 1, name: "4-Post" },
				{ id: 2, name: "Activestor" },
				{ id: 3, name: "ActivRAC" },
				 */
				{ id: 4, name: "Art Rack" },
				/*
				{ id: 5, name: "Cantilever" },
				 */
				{ id: 6, name: "Lockers" },
				/*
				{ id: 7, name: "Doors & Drawers" },
				{ id: 9, name: "FrameWRX" },
				{ id: 10, name: "Grow Crosswalk" },
				{ id: 11, name: "Gun Racks" },
				{ id: 12, name: "Laterals" },
				{ id: 13, name: "Museum Cabinets" },
				{ id: 14, name: "Parachute/Universal Container" },
				{ id: 15, name: "Personal Storage Locker" },
				{ id: 16, name: "RaptorRAC Widespan" },
				 */
				{ id: 17, name: "Mobile" },
				/*
				{ id: 20, name: "UEWSS" },
				 */
				{ id: 21, name: "Weapons Storage" },
				/*
				{ id: 25, name: "Widespan Grow" },
				{ id: 26, name: "Xtend" },
				 */
				{ id: 27, name: "Other" },
			],

			/*
			   4-Post (door and drawers)
               Activestor
               Mobile (WH, SW, AR)
               Art Rack
               Cantilever
               Day Use Lockers
               Evidence Lockers
               FrameWRX
               GROW
               HighBay (Shelving, Xtend)
               Laterals
               Museum Cabinets
               Military Products (UEWSS, Parachute/Universal Container, others?) 
               Weapons Storage (Universal Weapons Rack, Shipboard UWR, Weapons Rack III)
               RaptorRAC Widespan
			   */

		};
	},
	watch: {
	search(newValue) {
      // When user clears the input (types back to empty), allow searching again
      if (newValue.trim() === '') {
        this.searchStarted = false;
      }
    },

	/*
   '$route.query.search'(newSearch) {
    this.searchStarted = !!newSearch;

    if (newSearch) {
      this.search = newSearch;  // ← Restore the search term from URL
    } else {
      this.search = '';         // Clear when no search param
    }

    // Optional: Always go to page 1 when search query changes
    if (this.$route.query.page && this.$route.query.page !== '1') {
      this.setPage(1);
    }
    },
	*/
    complete(newValue, oldValue) {
		// Check for transitions from 0 to 1
		// console.log('Congrats value:', this.congrats);

		if ((oldValue === 0 && newValue === 1) && this.congrats == 1) {
			this.onCompleteChangedFromZeroToOne();
		}
		// Check for transitions from 9 to 10
		else if ((oldValue === 9 && newValue === 10) && this.congrats == 1) {
			this.onCompleteChangedFromNineToTen();
		}
		// Check for transitions from 19 to 20
		else if ((oldValue === 29 && newValue === 30) && this.congrats == 1) {
			this.onCompleteChangedFromNineteenToTwenty();
		}

		},
	},
	methods: {
		firstLoad: function() {
			//this.loading = true;
			this.loadContent();
        },
		openPdfInNewTab: function (pdfUrl) {
			window.open(pdfUrl, '_blank', 'noopener,noreferrer')
		},
		clearSearch() {
			this.searchStarted = false;
			this.search = "";
			this.selectedProduct = null;
  			this.activeProduct = null;
			this.updateURL();
		},
		searchPosts() {
			this.searchStarted = true;
			this.activeProduct = this.selectedProduct;
			this.currPage = 1;
			this.updateURL();
		},
		updateURL() {
			const query = { ...this.$route.query };

			// Handle search
			if (this.searchStarted && this.search.trim()) {
				query.search = this.search.trim();
			} else {
				delete query.search;
			}

			// Handle selectedProduct
			if (this.activeProduct) {
				query.product = this.activeProduct;
			} else {
				delete query.product;
			}

			// Always reset to page 1 when search or product filter changes
			// (Only if it's not already page 1, to avoid unnecessary history entries)
			if (query.search !== this.$route.query.search || query.product !== this.$route.query.product) {
				query.page = '1'; // Use string to match Vue Router behavior
			}

			// Push the new query (only if it actually changed)
			if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
				this.$router.push({ query });
			}
		},
		setPage(idx) {
			if (idx <= 0 || idx > this.totalPage) return;
			this.currPage = idx;
			this.$router.push({ query: { ...this.$route.query, page: idx } });
		},

        loadContent: function() {
			this.loading = true;
			
				return axios
					.get(`${this.server}/api/v1/product-courses/${this.courseid}/${this.USERID}`, auth)
					.then((response) => {
						console.log(response);
						this.course = response.data;
						// this.countComplete();
						this.loading = false;
						this.$nextTick(() => {
						const el = document.getElementById("pag");
						if (el) {
							el.scrollIntoView({ behavior: "smooth", block: "start" });
							// or: window.scrollTo({ top: 0, behavior: "smooth" });
						}
						});

					})
					.catch((error) => {
						if (error.request.status === 401) {
							this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
							this.$router.push("/");
						}
					});
		
		},

		loadNewContent: function() {			
				return axios
					.get(`${this.server}/api/v1/product-courses/${this.courseid}/${this.USERID}`, auth)
					.then((response) => {
						//console.log(response);
						this.course = response.data;
						// console.log("new content loaded")
						})
						.catch((error) => {
							if (error.request.status === 401) {
								this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
								this.$router.push("/");
							}
							// console.error("Error loading new content:", error);
						});
		},

		completeQuiz: function(){
			

			const PAYLOAD = {
    			ModuleID: this.courseid,
    			UserID: this.USERID,
				BlockID: this.lightboxQuiz.BlockID,
			}

			return axios
			.post(`${this.server}/api/v1/product-quiz`, PAYLOAD, auth)
			.then((response) => {
				this.loadNewContent();			
			})
			.catch((error) => {
				if (error.request.status === 401) {
					this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
					this.$router.push("/");
				}
				// console.error("Error loading data:", error);
				
			});
		},
		countComplete: function(){
			let count = this.trainingData.filter(item => item.complete === "true").length;

			this.complete = count;
			// alert(count);
			// console.log("ran")
		},
		congratsExplorer: function (link, type) {
				window.scrollTo(0, 0);
				this.$swal({
					html:
						'<div><h2 style="color: #000; margin-bottom: 5px;">Congratulations!</h2> <p style="font-weight: 300;">You\'ve just unlocked the CET Explorer Badge!</p>' +
						'<div style="text-align: left;"><small>' +
						'<br/>' +
						'</small><div style="background: #1b484e; text-align: center; padding: 20px; border-radius: 8px;"><img style="width: 150px;" src="/training-images/explorer-badge.svg" /><p style="color: #fff; margin-top: 10px;"><b>Explorer</b></p></div></div></div>',
					showCloseButton: false,
					showCancelButton: false,
					denyButtonText: `No`,
					customClass: {
						cancelButton: 'order-1 right-gap',
						confirmButton: 'order-2',
					}
				});
		},
		congratsVisionary: function (link, type) {
				window.scrollTo(0, 0);
				this.$swal({
					html:
						'<div><h2 style="color: #000; margin-bottom: 5px;">Congratulations!</h2> <p style="font-weight: 300;">You\'ve just unlocked the CET Visionary Badge!</p>' +
						'<div style="text-align: left;"><small>' +
						'<br/>' +
						'</small><div style="background: #1b484e; text-align: center; padding: 20px; border-radius: 8px;"><img style="width: 150px;" src="/training-images/visionary-badge.svg" /><p style="color: #fff; margin-top: 10px; margin-bottom:0;"><b>Visionary</b></p></div></div></div>',
					showCloseButton: false,
					showCancelButton: false,
					denyButtonText: `No`,
					customClass: {
						cancelButton: 'order-1 right-gap',
						confirmButton: 'order-2',
					}
				});
		},
		congratsInnovator: function (link, type) {
				window.scrollTo(0, 0);
				this.$swal({
					html:
						'<div><h2 style="color: #000; margin-bottom: 5px;">Congratulations!</h2> <p style="font-weight: 300;">You\'ve just unlocked the CET Innovator Badge!</p>' +
						'<div style="text-align: left;"><small>' +
						'<br/>' +
						'</small><div style="background: #1b484e; text-align: center; padding: 20px; border-radius: 8px;"><img style="width: 150px;" src="/training-images/innovator-badge.svg" /><p style="color: #fff; margin-top: 10px; margin-bottom:0;"><b>Innovator</b></p></div></div></div>',
					showCloseButton: false,
					showCancelButton: false,
					denyButtonText: `No`,
					customClass: {
						cancelButton: 'order-1 right-gap',
						confirmButton: 'order-2',
					}
				});
		},
		onCompleteChangedFromZeroToOne() {
				this.congratsExplorer();
				// alert('Complete changed from 0 to 1');

		},
		onCompleteChangedFromNineToTen() {
				this.congratsVisionary();
				// alert('Complete changed from 9 to 10');
		},
		onCompleteChangedFromNineteenToTwenty() {
				this.congratsInnovator();
				// alert('Complete changed from 19 to 20');
		},
		roundedHalfHour(length) {
			return Math.round((Number(length) / 60) * 2) / 2;
		},
		closeLightbox() {
      		this.lightboxVideo = "";
    	},
		closeQuizLightbox() {
			this.congrats = 0;
      		this.lightboxQuiz = null;
			this.ModuleID = null;
    	},
		showLightboxQuiz(quiz, id) {
			this.congrats = 1;
			this.lightboxQuiz = quiz;
			this.ModuleID = id;
		},
		cleanMediaHtml(media) {
			// Step 1: Replace all instances of \&quot; with "
			let decodedMedia = media.replace(/\\&quot;/g, '"');
			
			// Step 2: Remove backslashes that were used for escaping
			decodedMedia = decodedMedia.replace(/\\/g, '');

			// Step 3: Return the decoded result
			return decodedMedia;
		},

		// Method to clean and set the video for the lightbox
		showLightboxVideo(media) {
			const cleanedHtml = this.cleanMediaHtml(media);
			this.lightboxVideo = cleanedHtml;
		},
	},
	filters: {
		truncate: function(value) {
		if (value.length > 200) {
			value = value.substring(0, 200) + "...";
		}
		return value;
		},
		
	},
	computed: {
		block3Docs() {
		return this.course.docs.filter(file => file.BlockID === 3)
		},
		block4Docs() {
		return this.course.docs.filter(file => file.BlockID === 4)
		},
		block3PublishedQuizzes() {
		return this.course?.quizzes?.filter(quiz => 
			quiz.BlockID === 3 && quiz.Published
		) || []
		},
		block4PublishedQuizzes() {
		return this.course?.quizzes?.filter(quiz => 
			quiz.BlockID === 4 && quiz.Published === 1
		) || []
		},
		block5Docs() {
		return this.course.docs.filter(file => file.BlockID === 5)
		},
		block5PublishedQuizzes() {
		return this.course?.quizzes?.filter(quiz => 
			quiz.BlockID === 5 && quiz.Published === 1
		) || []
		},
		showButton() {
			return this.search.trim().length > 0 || this.selectedProduct;
		},
		pageStart() {
			return (this.currPage - 1) * this.countOfPage;
		},
		totalPage() {
			return Math.ceil(this.courses.length / this.countOfPage);
		},
		activeNav() {
			return this.$store.state.activePage;
		},
		filteredPosts() {
			let results = this.trainingData; 
			// let results = this.courses; // or this.trainingData when you switch to API

			// Apply search filter (only if search is active and has text)
			if (this.searchStarted && this.search.trim().length > 0) {
			const term = this.search.toLowerCase();
			results = results.filter(item =>
				item.title.toLowerCase().includes(term) ||
				(item.description && item.description.toLowerCase().includes(term))
			);
			}

			if (this.activeProduct) {
				results = results.filter(item =>
					item.Category === this.activeProduct
				);
			}

			return results;
		},
		paginatedPosts() {
		// Sort filteredPosts by createdAt in descending order (newest first), then slice for pagination
		return [...this.filteredPosts]
			// .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
			.slice(this.pageStart, this.pageStart + this.countOfPage);
		},
		

		totalLength() {
			const totalMinutes = this.faqPosts.reduce((sum, item) => sum + item.length, 0);
			return (totalMinutes / 60).toFixed(2); // Returns result in hours with 2 decimal points
    	},
		totalMinutes() {
      		return this.faqPosts.reduce((total, course) => total + course.length, 0);
    	},
		// Convert minutes to hours, rounding to the nearest half-hour
		roundedTotalHours() {
			const hours = this.totalMinutes / 60;
			return Math.round(hours * 2) / 2; // Rounds to nearest half-hour
		},
		// Display 'hour' or 'hours' depending on total hours
		hourLabel() {
			return this.roundedTotalHours === 1 ? 'Hour' : 'Hours';
		},
		USERID() {
			return this.$store.state.user.UserId;
		},
	},
	created() {
		this.$store.commit("showNavigation");
		this.courseid = this.$route.params.courseid || null;   // ← change .id → .courseid
  		console.log('Course ID:', this.courseid);
	},

	mounted() {
		this.firstLoad();
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.search{
  margin-left: auto;
}
.search-btns {
  display: flex;
  margin-top: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 23px 10px;
  cursor: pointer;
  max-height: 40px;
}
.search-btns .clear {
  margin-left: auto;
}
.search-btns .search {
  margin-left: 5px;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 14px;
  border: none;
  background: none;
}
.clear-hide {
  display: none !important;
}
.input-wrap {
  position: relative;
  display: block;
}
.right-side{
  display: flex;
}
.thesearchbutton{
  margin-left: auto;
}

.bgwhite {
	background: #fff;
}
.faq-heading {
	margin-bottom: 0 !important;
}
.collapse {
	padding: 0px 10px !important;
}
.collapse.show {
	padding: 0px 22px !important;
}
.faq-01 .btn {
	text-decoration: none !important;
}
.faq-01 .btn:hover {
	text-decoration: none !important;
}

.btn-link {
	color: #333;
}

.btn-link i {
	color: rgba(92, 109, 126, 0.9);
}

.btn-link:hover {
	color: #000;
	text-decoration: none !important;
	background-color: transparent;
	border-color: transparent;
}

.btn-link:focus {
	color: #000;
	text-decoration: none !important;
}

.accordion h5 {
	margin-bottom: 0 !important;
	font-weight: bold !important;
	font-size: 1.1em !important;
	line-height: 1.2;
}

.accordion div {
	padding: 10px;
}
.pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.header-divide {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.vid-link:hover{
	text-decoration: underline;
	cursor: pointer;
}

.complete {
	position: relative;
	display: inline-block;
	color: black; /* Set text color */
}

.complete::after {
	content: "";
	position: absolute;
	left: 0;
	right: 0;
	top: 50%; /* Position the line */
	height: 2px; /* Adjust thickness */
	background-color: #00b4b4; /* Set line color */
	z-index: 1;
}
.closeX {
    color: #fff;
    font-size: 3em;
    position: absolute;
    top: 10px;
    left: 20px;
    cursor: pointer;
    -webkit-transition: color 0.5s ease;
    transition: color 0.5s ease;
}

.cool-desc {
  margin-top: 5px;
  min-height: 120px;
}

.doc-item{
	border-left: 4px solid;
    /* border-left-width: 4px; */
    padding-left: 1rem;
    border-color: rgb(229 231 235);
    list-style-type: none;
	margin-bottom: 10px;
}
.svg-style{

    width: 1.25rem;

    height: 1.25rem;

    margin-right: .25rem;

}
.svg-style2{

    width: 1rem;

    height: 1rem;

    margin-right: .25rem;

}

</style>
